import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import { useMarks } from '../../../DataStore/MarksContext';
import ajaxMark from '../../../util/remote/ajaxMark';

const AlertCopyMarks = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    const { copyMarks, setCopyMarks } = useMarks();

    const handleClose = () => setCopyMarks({ show: false, comment: null });


   if (!copyMarks.data) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxMark.copyMarks(copyMarks.data);
        setLoading(false);
        if(server_response.status === "OK"){
            copyMarks.callback();
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={copyMarks.show}
            onClose={handleClose}
            title="Marks Copier"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm
                    </button>
                    </>}
                </>
            }
        >


            {copyMarks.data && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Are you sure you want copy marks from the selected marks source to the specified marks destination ?</h5>

                <p className='text-secondary text-center' style={{fontSize: '14px'}}>This action will delete existing marks (if any) from the marks destination and replace them with the source marks.</p>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertCopyMarks;
